export default __webpack_public_path__ + "static/media/footgif.4206b5ae.gif";